import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { beachballIcon } from '@polkadot/ui-shared';
function Identicon({ address, className = '', size, style = {} }) {
    const updateElem = useCallback((node) => {
        node && node.appendChild(beachballIcon(address, { isAlternative: false, size }));
    }, [address, size]);
    return (_jsx("div", { className: className, ref: updateElem, style: style }));
}
export const Beachball = React.memo(Identicon);
